import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import indexRoutes from "./routes/indexRoutes";
import "moment/locale/zh-cn";
import "@/assets/stylus/antdChange.styl";
import "@/assets/stylus/base.styl";

// 时间信息汉化
// moment.locale('zh-cn');

// 设定开发者debug
console.kun = (info) => console.log(
  "%c -kunnisser-",
  "height:20px;padding:6px;color: #fff; background-image:-webkit-gradient(linear,left top,right top,color-stop(0,#323f53),color-stop(1,#2f5e99));",
  info,
);

// 定义总路由组件11
const hotRender = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component></Component>
    </AppContainer>,
    document.getElementById("root"),
  );
};

hotRender(indexRoutes);

// 模块热更新
if (module.hot) {
  module.hot.accept("./routes/indexRoutes", () => {
    const updatedIndexRoutes = indexRoutes.default;
    hotRender(updatedIndexRoutes);
  });
}



// WEBPACK FOOTER //
// ./src/AntD/index.js